import styled from 'styled-components';
import { variables } from 'variables';

export const NewMacroStep1SC = styled.div`
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.pageBackgroundColor};
  padding: ${variables.pageContentPadding}px;
  width: 100%;
  padding-right: 0;
  padding-bottom: 0;
  border-bottom: 4px solid ${(props) => props.theme.primaryDarkColor};
`;

export const SelectLanguage = styled.div`
  margin-top: 1em;
  margin-bottom: 2em;
  display: flex;
`;

export const Lang = styled.div`
  display: flex;
  margin-top: 1.5em;
  cursor: pointer;
  margin-right: 1.5em;
  h6 {
    margin: 0;
    margin-top: 3px;
    font-weight: bold;
  }
`;
